import {Directive, Input, OnChanges, SimpleChanges} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';

@Directive({
  selector: '[appDisableReactiveForms]'
})
export class DisableReactiveFormsDirective implements OnChanges {

  @Input() formGroup: FormGroup;
  @Input() _formControl: FormControl;
  @Input() appDisableReactiveForms: boolean;

  ngOnChanges(changes: SimpleChanges) {
    if (!this.formGroup && !this._formControl) {
      throw new Error('DisableReactiveFormsDirective: formGroup or _formControl input needed.');
    }
    const control = this.formGroup || this._formControl;
    this.appDisableReactiveForms ? control.disable() : control.enable();
  }

}
